module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0030.png.aa31d064.jpg";